export default {
  invoicePages: {},
};
